import { transitionAgentModalForm } from '../../../actions/travelSs/agentModal';
import { getAgentForm } from '../../../selectors/travelSs/travelAgentModal';
import { FIELD_STATUS } from '../../../reducers/status';

export const agentModalFormRules = (store, next, action) => {
    const result = next(action);
    const motorAgentModalForm = getAgentForm(store.getState());
    const agentModalForm = validateAgentModalForm(motorAgentModalForm);
    const formAction = agentModalForm ? transitionAgentModalForm.formValid() : transitionAgentModalForm.formInvalid();
    console.log(agentModalForm, "jlkjlkj")
    store.dispatch(formAction);
    return result;
};

const validateAgentModalForm = (formFields) => {
    return (
        formFields.name &&
        formFields.name.status === FIELD_STATUS.VALID &&
        formFields.agentCode &&
        formFields.agentCode.status === FIELD_STATUS.VALID
    );
};
